
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Comment créer un post viral sur les réseaux sociaux ?",
    description:
      "Découvrez les secrets du buzz sur les réseaux sociaux : formats gagnants, émotions à exploiter et stratégies d’engagement. ALEO vous aide à booster vos réseaux !",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
